/* CUSTOM_DONETRIGGERS_BY_CLAUDE (AIOPS ae1b544a65d0, Ryan 2026-09-24)
   ─────────────────────────────────────────────────────────────────────────────
   Settings → Admin: File Mail When The Work Is Done — the JS half. Markup in
   snippets/rep-settings-done-triggers.liquid.

   ⛔ ITS OWN ASSET BECAUSE THE SECTION IS FULL — rep-quote-settings.liquid sits within a few KB of
   Shopify's 256 KB cap. Same rule and the same precedent as rep-settings-parked-mail.js.

   ⛔ IT POSTS ONLY ITS OWN FIELD. /order-filing-config merges field by field and an ABSENT field
   keeps its prior value, so this Save cannot disturb the filing switches next door.

   The list below the switch is GET /admin/order-mail/inbox-sweep — the sweep's own dry run. It
   moves nothing and wakes nobody; POST with {act:true} is the real pass and is not wired to a
   button here on purpose (the cron runs it every weekday morning).

   Loaded deferred from the section after custom-rep-portal.js (which defines
   window.RepPortal.API); runs on DOMContentLoaded. showMsg / hideMsg are the section's two
   helpers, copied because they are IIFE-local there. */
(function () {
  'use strict';

  function showMsg(el, text, type) {
    if (!el) return;
    el.textContent = text;
    el.className = 'rep-settings__message rep-settings__message--visible rep-settings__message--' + type;
  }
  function hideMsg(el) {
    if (!el) return;
    el.className = 'rep-settings__message';
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function initDoneTriggers() {
    if (!window.RepPortal || !window.RepPortal.API) return;
    var box = document.getElementById('settings-donetriggers-enabled');
    var btn = document.getElementById('settings-donetriggers-btn');
    var msg = document.getElementById('settings-donetriggers-msg');
    var refresh = document.getElementById('settings-donetriggers-refresh');
    var list = document.getElementById('settings-donetriggers-list');
    if (!box || !btn) return;

    /* ⛔ NOTHING IS DEFAULTED IN THE MARKUP — the box is filled from the server, so a failed load
       can never look like "off" and then SAVE that over a real setting. Save is disabled until then. */
    btn.disabled = true;
    /* CUSTOM_SWEEPHOURS_BY_CLAUDE (ONYX 6d79f76d6057, Ryan 2026-10-15) - the inbox check's hours + age, their own Save.
       ⛔ Filled from the server like the box above; the Save stays disabled until then, so a failed load can never save
       an empty list over Ryan's hours. */
    var hoursBox = document.getElementById('settings-donetriggers-hours');
    var ageInput = document.getElementById('settings-donetriggers-age');
    var hoursBtn = document.getElementById('settings-donetriggers-hours-btn');
    var hoursMsg = document.getElementById('settings-donetriggers-hours-msg');
    if (hoursBtn) hoursBtn.disabled = true;
    function hourLabel(h) { return (h % 12 === 0 ? 12 : h % 12) + ' ' + (h < 12 ? 'AM' : 'PM'); }
    function drawHours(selected) {
      if (!hoursBox) return;
      var html = '';
      for (var h = 5; h <= 20; h++) {
        html += '<label style="white-space: nowrap;"><input type="checkbox" data-sweep-hour="' + h + '"' + (selected.indexOf(h) !== -1 ? ' checked' : '') + ' style="margin-right: 4px;">' + esc(hourLabel(h)) + '</label>';
      }
      hoursBox.innerHTML = html;
    }

    (function load() {
      window.RepPortal.API.get('/order-filing-config').then(function (cfg) {
        box.checked = !(cfg && cfg.autoFileOnDone === false);
        btn.disabled = false;
        drawHours((cfg && Array.isArray(cfg.sweepHoursMT)) ? cfg.sweepHoursMT : [7, 13]);
        if (ageInput) ageInput.value = (cfg && cfg.sweepOlderThanBusinessHours) || 4;
        if (hoursBtn) hoursBtn.disabled = false;
      }).catch(function () {
        showMsg(msg, 'Could not load the current setting - reload the page before saving.', 'error');
      });
    })();

    btn.addEventListener('click', function () {
      hideMsg(msg);
      btn.disabled = true;
      var orig = btn.textContent;
      btn.textContent = 'Saving...';
      var on = !!box.checked;
      window.RepPortal.API.post('/order-filing-config', { autoFileOnDone: on }).then(function () {
        showMsg(msg, on
          ? 'Saved - mail files itself once its work is done. Each move leaves an "Auto-filed" line on the deal.'
          : 'Saved - nothing files automatically. The weekday sweep still lists what is left with nothing pending.', 'success');
      }).catch(function (e) {
        showMsg(msg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
      }).then(function () {
        btn.disabled = false;
        btn.textContent = orig;
      });
    });

    if (hoursBtn) hoursBtn.addEventListener('click', function () {
      hideMsg(hoursMsg);
      var picked = [];
      var boxes = hoursBox ? hoursBox.querySelectorAll('input[data-sweep-hour]') : [];
      for (var i = 0; i < boxes.length; i++) if (boxes[i].checked) picked.push(Number(boxes[i].getAttribute('data-sweep-hour')));
      var age = Number(ageInput && ageInput.value);
      if (!picked.length || picked.length > 6) { showMsg(hoursMsg, 'Pick between one and six times.', 'error'); return; }
      if (!(age >= 1 && age <= 40 && Math.round(age) === age)) { showMsg(hoursMsg, 'Business hours must be a whole number from 1 to 40.', 'error'); return; }
      hoursBtn.disabled = true;
      var orig = hoursBtn.textContent;
      hoursBtn.textContent = 'Saving...';
      window.RepPortal.API.post('/order-filing-config', { sweepHoursMT: picked, sweepOlderThanBusinessHours: age }).then(function (cfg) {
        var hrs = (cfg && cfg.sweepHoursMT) || picked;
        showMsg(hoursMsg, 'Saved - the inbox is checked on workdays at ' + hrs.map(hourLabel).join(' and ') + ' Mountain, counting an email as missed after ' + ((cfg && cfg.sweepOlderThanBusinessHours) || age) + ' business hours.', 'success');
      }).catch(function (e) {
        showMsg(hoursMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
      }).then(function () {
        hoursBtn.disabled = false;
        hoursBtn.textContent = orig;
      });
    });

    function loadSweep() {
      if (!list) return;
      list.innerHTML = '<p style="font-size:13px;color:var(--rq-text-secondary);margin:0;">Reading the inbox&hellip;</p>';
      window.RepPortal.API.get('/admin/order-mail/inbox-sweep').then(function (d) {
        var rows = (d && d.rows) || [];
        var excluded = (d && d.excluded) || [];
        if (!rows.length) {
          /* ⚠️ "Nothing pending" is a real answer, worded so it cannot be mistaken for a failed read. */
          list.innerHTML = '<p style="font-size:13px;color:var(--rq-text-secondary);margin:0;">Nothing older than four business hours is sitting there with nothing pending'
            + (excluded.length ? ' (' + excluded.length + ' message' + (excluded.length === 1 ? '' : 's') + ' left out: pending work, parked on purpose, or an auto-reply).' : '.') + '</p>';
          return;
        }
        var html = '';
        rows.forEach(function (r) {
          var tag = r.likelyTrigger && r.likelyTrigger.tag ? r.likelyTrigger.tag : null;
          html += '<div style="border:1px dashed var(--rq-border,#1e2a42);border-radius:8px;padding:8px 12px;margin:0 0 6px;">'
            + '<div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;">'
            + '<strong style="font-size:13px;">' + esc(r.ref || 'no deal named') + '</strong>'
            + '<span style="font-size:12px;color:var(--rq-text-secondary);">' + esc(r.from || '') + ' &middot; ' + esc(String(r.ageHours)) + 'h old'
            + (tag ? ' &middot; looks done: ' + esc(tag) : '') + (r.fileAttempt ? ' &middot; could not file: ' + esc(r.fileAttempt) : '') + '</span></div>'
            + '<div style="font-size:12px;color:var(--rq-text-secondary);margin-top:4px;">' + esc(r.subject) + '</div>'
            + '</div>';
        });
        if (excluded.length) {
          html += '<p style="font-size:12px;color:var(--rq-text-secondary);margin:8px 0 0;">' + excluded.length + ' message' + (excluded.length === 1 ? '' : 's')
            + ' left out: pending work on the deal, parked on purpose, or an auto-reply.</p>';
        }
        list.innerHTML = html;
      }).catch(function (e) {
        list.innerHTML = '<p style="font-size:13px;color:var(--rq-error,#e08a80);margin:0;">Could not read the inbox: '
          + esc(e && e.message ? e.message : 'unknown error') + '</p>';
      });
    }
    if (refresh) refresh.addEventListener('click', loadSweep);
    loadSweep();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDoneTriggers);
  } else {
    initDoneTriggers();
  }
})();
